module.exports = __webpack_public_path__ + "static/media/logoWarriorsSmall.de9d3a12.jpg";